var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#25C661"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24Z",
    fill: "#25C661"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2 12.6C32.2 9.6 28.2 8 24 8C15.2 8 8 15.2 8 24C8 26.8 8.80001 29.6 10.2 32L8 40L16.4 37.8C18.8 39 21.4 39.8 24 39.8C32.8 39.8 40 32.6 40 23.8C40 19.6 38.2 15.6 35.2 12.6ZM24 37.2C21.6 37.2 19.2 36.6 17.2 35.4L16.8 35.2L11.8 36.6L13.2 31.8L12.8 31.2C11.4 29 10.8 26.6 10.8 24.2C10.8 17 16.8 11 24 11C27.6 11 30.8 12.4 33.4 14.8C36 17.4 37.2 20.6 37.2 24.2C37.2 31.2 31.4 37.2 24 37.2ZM31.2 27.2C30.8 27 28.8 26 28.4 26C28 25.8 27.8 25.8 27.6 26.2C27.4 26.6 26.6 27.4 26.4 27.8C26.2 28 26 28 25.6 28C25.2 27.8 24 27.4 22.4 26C21.2 25 20.4 23.6 20.2 23.2C20 22.8 20.2 22.6 20.4 22.4C20.6 22.2 20.8 22 21 21.8C21.2 21.6 21.2 21.4 21.4 21.2C21.6 21 21.4 20.8 21.4 20.6C21.4 20.4 20.6 18.4 20.2 17.6C20 17 19.6 17 19.4 17C19.2 17 19 17 18.6 17C18.4 17 18 17 17.6 17.4C17.2 17.8 16.2 18.8 16.2 20.8C16.2 22.8 17.6 24.6 17.8 25C18 25.2 20.6 29.4 24.6 31C28 32.4 28.6 32 29.4 32C30.2 32 31.8 31 32 30.2C32.4 29.2 32.4 28.4 32.2 28.4C32 27.4 31.6 27.4 31.2 27.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.f4234b249f9f0307ec8d37d083d3feaa.svg";
export { ForwardRef as ReactComponent };